import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

import type { TGetCardFacesParams } from './types';

const [
  useCardPageFilters,
  CardPageFiltersProvider,
] = createGenericFiltersContext<TGetCardFacesParams>({
  displayName: 'CardPageFilters',
});

export {
  useCardPageFilters,
  CardPageFiltersProvider,
};
